import request from '@/utils/request';

/**
 * 课程详情
 * @returns {Promise<*>}
 */
export async function getCourseDetail(params) {
  return request('/api/zeyin_school/app/course/detail', { params });

}


/**
 * 课程目录
 * @returns {Promise<*>}
 */
export async function getCourseDirectory(params) {
  return request('/api/zeyin_school/app/course/courseDirectory', { params });

}


/**
 * 课程目录详情
 * @returns {Promise<*>}
 */
export async function getDirectoryDetail(params) {
  return request('/api/zeyin_school/app/course/courseDirectory/detail', { params });

}

/**
 * 目录播放结束
 * @returns {Promise<*>}
 */
export async function dirPlayEnd(params) {
  return request('/api/zeyin_school/app/course/courseDirectory/over', { params });
}

/**
 * 课程评论列表
 * @returns {Promise<*>}
 */
export async function getCommentList(params) {
  return request('/api/zeyin_school/app/course/courseComment', { params });
}

/**
* 课程评论详情
* @returns {Promise<*>}
*/
export async function getCommentDetail(params) {
  return request('/api/zeyin_school/app/course/courseComment/detail', { params });
}

/**
* 课程点赞
* @returns {Promise<*>}
*/
export async function courseLike(params) {
  return request('/api/zeyin_school/app/memberCourse/clickLike', { params });
}


/**
 * 课程收藏
 * @returns {Promise<*>}
 */
export async function courseCollect(params) {
  return request('/api/zeyin_school/app/memberCourse/clickCollect', { params });
}

/**
 * 课程分享
 * @returns {Promise<*>}
 */
export async function courseShare(params) {
  return request('/api/zeyin_school/app/memberCourse/clickShare', { params });
}

/**
 * 课程评论
 * @returns {Promise<*>}
 */
export async function courseComment(params) {
  return request('/api/zeyin_school/app/memberCourse/comment', { params });
}


/**
 * 课程点赞评论
 * @returns {Promise<*>}
 */
export async function commentLike(params) {
  return request('/api/zeyin_school/app/memberCourse/comment/clickLike', { params });
}



/**
 * 回复评论
 * @returns {Promise<*>}
 */
export async function commentReply(params) {
  console.log(params);
  return request('/api/zeyin_school/app/memberCourse/comment/reply', { params });
}

/**
 * 删除评论
 * @returns {Promise<*>}
 */
export async function commentDelete(params) {
  return request('/api/zeyin_school/app/memberCourse/comment/delete', { params });
}



/**
 * 删除评论回复
 * @returns {Promise<*>}
 */
export async function replyCommentDelete(params) {
  return request('/api/zeyin_school/app/memberCourse/comment/reply/delete', { params });
}



/**
 * 课程兑换
 * @returns {Promise<*>}
 */
export async function courseConvert(params) {
  return request('/api/zeyin_school/app/memberCourse/convert', { params });
}
